export default "__VITE_ASSET__BeCUcVik__"